// 환경변수 설정
export const config = {
  // API
  apiUrl: import.meta.env.VITE_API_URL || 'https://5gtpi64y66.execute-api.ap-northeast-2.amazonaws.com/dev',
  wsUrl: import.meta.env.VITE_WS_URL || 'wss://02gm5gnan1.execute-api.ap-northeast-2.amazonaws.com/dev',
  
  // AWS Cognito
  cognitoRegion: import.meta.env.VITE_COGNITO_REGION || 'ap-northeast-2',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'ap-northeast-2_MMdNmaYj9',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '7r7lp742om21r0b740qvq820f1',
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || 'debate-battle-dev-238663298897.auth.ap-northeast-2.amazoncognito.com',
  
  // OAuth Redirect
  redirectUri: import.meta.env.VITE_REDIRECT_URI || 
    (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173'),
  
  // IVS
  ivsRegion: import.meta.env.VITE_IVS_REGION || 'ap-northeast-2',
  
  // Ads
  adMobAppId: import.meta.env.VITE_ADMOB_APP_ID || '',
  
  // App
  appName: 'Voice Debate Battle',
  debateDuration: 300, // 5분 (초)
  
  // Feature Flags
  features: {
    socialLogin: true,
    recording: false,
    chat: true, // 텍스트 채팅 먼저 구현
  },
} as const;

export type Config = typeof config;
